import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import axios from "axios";

import { getSubDomain, getUserData } from "../hooks/HelperFunctions";

import MyTakbirHome from "./index-main";

import Header from "../components/Header/Header";
import Banner from "../components/Banner/Banner";
import Session from "../components/Session/Session";
import TracksCards from "../components/Tracks/TracksCards";
import BottomCart from "../components/BottomCart/BottomCart";

import EarnCertificate from "../components/EarnCertificate/EarnCertificate";

import SupportUsSection from "../components/Support/SupportUsSection";
import Faq from "../components/Faq/Faq";
import DfDonation from "../components/DfDonation/DfDonation";
import Instructor from "../components/Instructor/Instructor";
import TestimonialsSec from "../components/Testimonials/TestimonialsSec";
import { apiRequest } from "../utils/axiosInstance";

import globalMeta from "../seo/globalMeta";
import { NextSeo } from "next-seo";
import { useShoppingCart } from "../contexts/CartContext";

import { messaging } from "../lib/firebase";
import { getToken, onMessage } from "firebase/messaging";
import Footer from "../components/MainWebsiteComponent/Footer/Footer";
import Head from "next/head";

function HomePage(props) {
  const [token, setToken] = useState("");

  const router = useRouter();

  const { filterCheckBoxData } = props;
  const {
    updateCart,
    setUpdateCart,
    openSignUpModel,
    setOpenSignUpModel,
    enrollNowHandler,
    showSnackbarMessage,
  } = props;
  const { orgData, subdomain, setOpenBackdrop, orgOgImage } = props;

  const { cartItems } = useShoppingCart();

  // const [showNotification, setShowNotification] = useState(false);
  // const [notificationMessage, setNotificationMessage] = useState("");

  useEffect(() => {
    // show snackbar message if any
    const { signout, userEmailVerificationToken } = router.query;

    // if(orgData?.orgId > 0){
    //   localStorage.setItem("orgId", orgData?.orgId);
    // }

    if (signout == "success") {
      // show logput snackbar
      showSnackbarMessage(
        "success",
        "You’ve successfully signed out of Takbir Portal. Come back soon!",
      );
      setTimeout(() => {
        // clear all local data
        localStorage.clear();
        // goto home page and reload
        window.location.replace(window.location.origin);
      }, 3000);
    } else if (userEmailVerificationToken) {
      const apiBaseUrl =
        process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
          ? process.env.NEXT_PUBLIC_API_URL_PROD
          : process.env.NEXT_PUBLIC_API_URL_DEV;
      setOpenBackdrop(true);
      axios
        .post(`${apiBaseUrl}/verifyEmail`, {
          token: userEmailVerificationToken,
        })
        .then((response) => showEmailVerifyMessage(response))
        .catch((err) => {
          console.log(err);
          if (err.response.data.message) {
            showSnackbarMessage("error", err.response.data.message);
          }
        });
    }

    // check we have any pending enrollment
    const pendingOperation = localStorage.getItem("pendingOperation");
    if (pendingOperation === "enrollment") {
      // get course data and trigger enroll now handler
      const pendingOperationData = JSON.parse(
        localStorage.getItem("pendingOperationData"),
      );
      localStorage.removeItem("pendingOperation");
      localStorage.removeItem("pendingOperationData");
      const userAuthenticated = localStorage.getItem("userAuthenticated");
      enrollNowHandler(pendingOperationData, userAuthenticated);
    }

    // code for retriving already enrolled courses
    const apiBaseUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_API_URL_PROD
        : process.env.NEXT_PUBLIC_API_URL_DEV;

    const userData = getUserData();
    const userId = userData.id;

    if (userId) {
      axios
        .get(`${apiBaseUrl}/getAlreadyEnrolledCourses?userId=${userId}`)
        .then((result) => {
          localStorage.setItem(
            "alreadyEnrolledCourses",
            JSON.stringify(result.data.body),
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const showEmailVerifyMessage = (result) => {
    console.log(result);

    const response = result.data;

    setOpenBackdrop(false);

    console.log(response.message);

    if (response.error) {
      showSnackbarMessage("error", response.message);
    } else {
      console.log(response.message);
      showSnackbarMessage("success", response.message);
      localStorage.setItem("userVerified", true);
    }

    setTimeout(() => {
      // goto home page and reload
      window.location.replace(window.location.origin);
    }, 3000);
  };

  useEffect(() => {
    if (cartItems?.length > 0) {
      const findOnlyCourses = cartItems?.filter((course) => course?.courseId);
      localStorage.setItem("selectedCourses", JSON.stringify(findOnlyCourses));
    }
  }, [cartItems]);

  //   useEffect(() => {
  //   // Listen for messages from service worker
  //   const handleServiceWorkerMessage = (event) => {
  //     // console.log('Received message from service worker:', event.data);
  //     if (event.data && event.data.type === 'SHOW_ALERT') {
  //       // Display the notification message in an alert
  //       // console.log('Notification received:', event.data.title, event.data.body);
  //       setShowNotification(true);
  //       setNotificationMessage(`${event.data.body}`);
  //     }
  //   };

  //   if ('serviceWorker' in navigator) {
  //     navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);
  //   }

  //   return () => {
  //     if ('serviceWorker' in navigator) {
  //       navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
  //     }
  //   };
  // }, []);
  // ...existing code...
  useEffect(() => {
    const requestNotificationPermission = async () => {
      try {
        const permission = await Notification.requestPermission();

        if (permission === "granted") {
          console.log("Notification permission granted.");

          // For FCM v1, you don't need vapidKey
          const token = await getToken(messaging);

          if (token) {
            // console.log('FCM Token:', token);
            // Send token to your server
            const apiBaseUrl =
              process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
                ? process.env.NEXT_PUBLIC_API_URL_PROD
                : process.env.NEXT_PUBLIC_API_URL_DEV;

            const userAuthenticated = localStorage.getItem("userAuthenticated");
            console.log("userAuthenticated", userAuthenticated);

            if (userAuthenticated === "true") {
              const userId = getUserData().id;

              // console.log("userId", userId);

              const data = await apiRequest("/save-fcm-token", "POST", {
                token,
                userId,
              });
              // console.log("FCM Token saved successfully:", data);
            }
          }
        } else {
          console.log("Notification permission denied.");
        }
      } catch (error) {
        console.error("Error requesting notification permission:", error);
      }
    };

    // Handle foreground messages
    if (
      typeof window !== "undefined" &&
      "serviceWorker" in navigator &&
      messaging
    ) {
      onMessage(messaging, (payload) => {
        // console.log('Message received in foreground:', payload);
        showSnackbarMessage("info", payload.notification.title);
      });

      requestNotificationPermission();
    }
  }, []);
  // ...existing code...

  const [password, setPassword] = useState("");
  const [passwordValidation, setPasswordValidation] = useState(true);

  const url =
    process.env.NEXT_PUBLIC_APP_URL || "https://main-stage.mytakbir.com";
  return (
    <div>
      {subdomain == "main-dev" ||
      subdomain == "main-stage" ||
      subdomain == "" ||
      subdomain == "www" ? (
        <MyTakbirHome
          subdomain={subdomain}
          updateCart={updateCart}
          setUpdateCart={setUpdateCart}
          openSignUpModel={openSignUpModel}
          setOpenSignUpModel={setOpenSignUpModel}
          enrollNowHandler={enrollNowHandler}
          filterCheckBoxData={filterCheckBoxData}
        />
      ) : (
        <>
          <Head>
            <meta charSet="utf-8" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0"
            />
            <meta name="theme-color" content="#000000" />
            <meta
              name="robots"
              content={
                process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
                  ? "index, follow"
                  : "noindex, nofollow"
              }
            />
            <meta
              name="googlebot"
              content={
                process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
                  ? "index, follow"
                  : "noindex, nofollow"
              }
            />
            <meta name="referrer" content="no-referrer-when-downgrade" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="website" />

            <title>
              Takbir - Best online Islamic learning and teaching site
            </title>
            <meta
              name="description"
              content="Takbir is a secured, simple and easy-to-use online learning platform for learners and teachers of Islam. Learn Islam, Iman, Ihsan, Tazkiya, Akhlaq, Quran, Hadith, Fiqh, Arabic and much more in one place."
            />
            <meta
              property="og:site_name"
              content="Takbir - Best online Islamic learning and teaching site "
            />
            <meta
              property="og:description"
              content="Takbir is a secured, simple and easy-to-use online learning platform for learners and teachers of Islam. Learn Islam, Iman, Ihsan, Tazkiya, Akhlaq, Quran, Hadith, Fiqh, Arabic and much more in one place."
            />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:url" content={url} />
            <meta
              property="og:title"
              content="Takbir - Best online Islamic learning and teaching site"
            />
            <meta
              property="og:image"
              content="https://cdn.mytakbir.com/static-assets/meta/web-takbir-img.png"
            />
            <meta
              property="og:image:secure_url"
              content="https://cdn.mytakbir.com/static-assets/meta/web-takbir-img.png"
            />

            <link
              rel="icon"
              href="https://cdn.mytakbir.com/static-assets/meta/takbir-lms-learning-management-system-muslim-favicon.png"
            />
            <link
              rel="apple-touch-icon"
              sizes="180x180"
              href="/apple-touch-icon.png"
            />
            <link
              rel="icon"
              type="image/png"
              sizes="32x32"
              href="/favicon.ico"
            />
            {/* <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" /> */}

            <script
              async
              src="https://www.googletagmanager.com/gtag/js?id=G-7XY3WGDSHE"
            ></script>

            <script
              id="google-analytics"
              dangerouslySetInnerHTML={{
                __html: `
                  window.dataLayer = window.dataLayer || [];
                  function gtag(){window.dataLayer.push(arguments);}
                  gtag('js', new Date());
                  gtag('config', 'G-7XY3WGDSHE');
                `,
              }}
            />

            <script
              id="mixpanel"
              dangerouslySetInnerHTML={{
                __html: `
                  (function(e,c){if(!c.__SV){var l,h;window.mixpanel=c;c._i=[];c.init=function(q,r,f){function t(d,a){var g=a.split(".");2==g.length&&(d=d[g[0]],a=g[1]);d[a]=function(){d.push([a].concat(Array.prototype.slice.call(arguments,0)))}}var b=c;"undefined"!==typeof f?b=c[f]=[]:f="mixpanel";b.people=b.people||[];b.toString=function(d){var a="mixpanel";"mixpanel"!==f&&(a+="."+f);d||(a+=" (stub)");return a};b.people.toString=function(){return b.toString(1)+".people (stub)"};l="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders start_session_recording stop_session_recording people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
                  for(h=0;h<l.length;h++)t(b,l[h]);var n="set set_once union unset remove delete".split(" ");b.get_group=function(){function d(p){a[p]=function(){b.push([g,[p].concat(Array.prototype.slice.call(arguments,0))])}}for(var a={},g=["get_group"].concat(Array.prototype.slice.call(arguments,0)),m=0;m<n.length;m++)d(n[m]);return a};c._i.push([q,r,f])};c.__SV=1.2;var k=e.createElement("script");k.type="text/javascript";k.async=!0;k.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"file:"===e.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\\/\\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";e=e.getElementsByTagName("script")[0];e.parentNode.insertBefore(k,e)}})(document,window.mixpanel||[]);
                  mixpanel.init('60e7a8f3c95c4e2b186ace1f2dc5aa09', {autocapture: true, record_sessions_percent: 100});
                `,
              }}
            />
          </Head>

          <Header
            subdomain={subdomain}
            updateCart={updateCart}
            setUpdateCart={setUpdateCart}
            openSignUpModel={openSignUpModel}
            enrollNowHandler={enrollNowHandler}
            setOpenSignUpModel={setOpenSignUpModel}
          />
          <Banner subdomain={subdomain} />

          <Session
            data={props.courses}
            setUpdateCart={setUpdateCart}
            enrollNowHandler={enrollNowHandler}
            setOpenSignUpModel={setOpenSignUpModel}
          />
          <TracksCards
            tracks={props.tracks}
            setUpdateCart={setUpdateCart}
            showTitle={true}
          />
          {/* <EarnCertificate /> */}
          {/* <TestimonialsSec data={testimonials} /> */}
          <SupportUsSection />
          <Instructor />
          {/* <Faq /> */}
          {/* <DfDonation /> */}
          <Footer />

          {cartItems?.length > 0 && (
            <BottomCart
              updateCart={updateCart}
              setOpenSignUpModel={setOpenSignUpModel}
            />
          )}
        </>
      )}
    </div>
  );
}

export async function getServerSideProps({ req }) {
  const subdomain = getSubDomain(req);

  const apiBaseUrl =
    process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
      ? process.env.NEXT_PUBLIC_API_URL_PROD
      : process.env.NEXT_PUBLIC_API_URL_DEV;

  let pageProps = {};

  if (
    subdomain == "main-dev" ||
    subdomain == "main-stage" ||
    subdomain == "www" ||
    subdomain == ""
  ) {
    const response = await fetch(`${apiBaseUrl}/getFilterCheckBoxData`);

    const filterCheckBoxData = await response.json();
    pageProps = {
      subdomain: subdomain,
      filterCheckBoxData: filterCheckBoxData,
    };
  } else {
    const orgDataResult = await axios.get(
      `${apiBaseUrl}/getOrgData?subdomain=${subdomain}`,
    );
    console.log(
      "DEBUG SERVER: Fetching courses from",
      `${apiBaseUrl}/getCourses?subdomain=${subdomain}`,
    );
    const coursesResult = await axios.get(
      `${apiBaseUrl}/getCourses?subdomain=${subdomain}`,
    );
    console.log(
      "DEBUG SERVER: Courses result body keys:",
      Object.keys(coursesResult.data.body || {}),
    );
    if (coursesResult.data.body) {
      console.log(
        "DEBUG SERVER: upcomming count:",
        coursesResult.data.body.upcomming?.length,
      );
      console.log(
        "DEBUG SERVER: upcoming count:",
        coursesResult.data.body.upcoming?.length,
      );
    }
    const tracksResult = await axios.get(
      `${apiBaseUrl}/getTrackCards?subdomain=${subdomain}`,
    );
    // const testimonialsResult = await axios.get(`${apiBaseUrl}/getTestimonials?subDomain=${subdomain}`);

    const orgOgImage = orgDataResult?.data?.orgsMetaData?.home?.meta_property
      ?.og_image
      ? orgDataResult.data.orgsMetaData.home.meta_property.og_image
      : null;

    pageProps = {
      subdomain: subdomain,
      courses: coursesResult.data.body,
      tracks: tracksResult.data.body,
      orgData: orgDataResult.data.body,
      orgOgImage: orgOgImage,
    };
  }

  return {
    props: pageProps,
  };
}

export default HomePage;
